import { Button, CssBaseline } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import MaterialTable from "material-table";
// @ts-ignore
import MUIEditor from "react-mui-draft-wysiwyg";
import LabelsContext from "../../../../lang/LabelsContext";
import { tableIcons } from "../../../system/material-table-utils/MaterialTableUtils";
import parse from "html-react-parser";
import NotesService, { NotesServiceType } from "./NotesService";
import { dateView, muiControls } from "../../../../utils/Utils";

export default function Notes() {
  const { Labels } = LabelsContext();
  const {
    article,
    openNoteDialog,
    openNoteDialogAction,
    closeNoteDialogAction,
    note,
    setNote,
    saveNote,
  }: NotesServiceType = NotesService();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        icons={tableIcons}
        columns={[
          { field: "date", title: Labels.DATE, render: (rowData) => <div>{dateView(rowData.date)}</div> },
          {
            field: "assistantEditor.firstName",
            title: Labels.AUTHOR,
            render: (rowData: any) => (
              <div>
                {rowData.assistantEditor.firstName} {rowData.assistantEditor.lastName}
              </div>
            ),
          },
          {
            field: "note",
            sorting: false,
            title: Labels.NOTE,
            render: (rowData) => <div>{parse(rowData.note ? rowData.note : "")}</div>,
          },
        ]}
        title={""}
        data={article.articleNotes}
        options={{
          actionsColumnIndex: -1,
          pageSize: 5,
        }}
        actions={[
          {
            icon: () => <AddCircleIcon color="action" />,
            onClick: (event, rowData: any) => openNoteDialogAction(),
            tooltip: Labels.ADD,
            position: "toolbar",
          },
        ]}
      />
      <Dialog maxWidth={"md"} open={openNoteDialog} onClose={closeNoteDialogAction} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{Labels.NOTE}</DialogTitle>
        <DialogContent>
          <MUIEditor
            config={{
              toolbar: { controls: muiControls },
              draftEditor: {
                stripPastedStyles: true,
              },
            }}
            editorState={note}
            onChange={(state: any) => {
              setNote(state);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeNoteDialogAction} color="primary">
            {Labels.CANCEL}
          </Button>
          <Button onClick={saveNote} color="primary" variant="contained">
            {Labels.SAVE}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
